module.exports = __webpack_public_path__ + "img/About_ys_big_4.e0b3da75.jpg";